module.exports = __webpack_public_path__ + "img/search.a3c50eb0.png";